<template>
  <div>
    <answer-header></answer-header>
    <img class="logo" src="../assets/logo.png">
    <div class="end-mod">
      <p class="fz32">
        ကုန္ဆံုးခ်ိန္: {{duration}}S
      </p>
      <p class="fz28">
        （ ေျဖဆိုသူ {{win}} ဦးထက္ပိုျမန္သည္ ）
      </p>
      <p class="fz32">
        ရမွတ္: {{score}}
      </p>
    </div>
    <div class="blk3">
      <div class="btn btn-block" @click="_goReview">အေျဖမွန္ကို ၾကည့္ရွဳရန္</div>
    </div>
<!--    <div class="blk4">-->
<!--      <div class="btn btn-block" @click="_showShare">အဆင့္မွ်ေဝ</div>-->
<!--    </div>-->

    <!-- <question></question> -->

    <mt-popup v-model="showSharePop" position="bottom" class='sharePop'>
      <social-sharing v-bind:url="shareUrl" v-bind:title="shareTitle" v-bind:description="shareDesc" v-bind:quote="shareDesc" hashtags="Prize,Quiz,Million MMK" inline-template>
        <div>
          <ul class='share-list'>
            <li class='share-item'>
              <network network="facebook">
                <i class="fa fa-facebook"></i> Facebook
              </network>
            </li>
            <li class='share-item'>
              <network network="googleplus">
                <i class="fa fa-google-plus"></i> Google +
              </network>
            </li>
            <li class='share-item'>
              <network network="linkedin">
                <i class="fa fa-linkedin"></i> LinkedIn
              </network>
            </li>
            <li class='share-item'>
              <network network="twitter">
                <i class="fa fa-twitter"></i> Twitter
              </network>
            </li>
            <li class='share-item'>
              <network network="vk">
                <i class="fa fa-vk"></i> VKontakte
              </network>
            </li>
            <li class='share-item'>
              <network network="whatsapp">
                <i class="fa fa-whatsapp"></i> Whatsapp
              </network>
            </li>
          </ul>
        </div>
      </social-sharing>
    </mt-popup>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import answerHeader from './Header'
import question from './Question'
export default {
  name: 'End',
  components: { answerHeader, question },
  computed: {
    ...mapState(['lang', 'langMap']),
  },
  data() {
    return {
      duration: '',
      score: '',
      win: '',
      showSharePop: false,
      shareUrl: 'http://qs.wobangta.com/#/share',
      shareTitle: '',
      shareDesc: '',
      questionId: this.$route.query.id
    }
  },
  created() {
    Utils.$ajax({
      type: 'post',
      url: '/core/result',
      data: {question_id: this.questionId}
    }).done(res => {
      if (res.code != 0) {
        this.$toast(res.msg);
      } else {
        this.duration = res.data.time;
        this.score = res.data.score;
        this.win = res.data.win
      }
    })
  },
  methods: {
    _goReview() {
      this.$router.push(`/review?id=${this.questionId}`)
    },
    _showShare() {
      Utils.$ajax({
          type: 'get',
          url: '/share/result'
      }).done(res=>{
          if(res.code != 0) return;
          this.showSharePop = true;
          this.shareTitle = res.data.title;
          this.shareDesc = res.data.desc;
          this.shareUrl = res.data.link;
      });
    }
  }
}

</script>
<style lang="scss">
.end-mod{
    text-align: center;
    color: #fff;
    line-height: 2em;
}

.blk3 {
  margin-top: rem(140);
}

.blk4 {
  margin-top: rem(74);
}

.sharePop {
  width: 100%;
  color: #000;
  padding: 20px 10px;
}

.share-item{
  display: inline-block;
  border: 1px #eee solid;
  margin: 5px;
  padding: .5em;
}

</style>



// WEBPACK FOOTER //
// src/components/End.vue